import { render, staticRenderFns } from "./RoleDialog.vue?vue&type=template&id=1dd8adf8&scoped=true&"
import script from "./RoleDialog.vue?vue&type=script&lang=js&"
export * from "./RoleDialog.vue?vue&type=script&lang=js&"
import style0 from "./RoleDialog.vue?vue&type=style&index=0&id=1dd8adf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8adf8",
  null
  
)

export default component.exports